export default __webpack_public_path__ + "static/media/page3.b3bf0390.jpg";